// @greenlight-spec: 10-security-compliance.md#compliance-evidence-not-compliance-bundles

import type { HipaaEvidence } from '@greenlight/contract';

import { escapeCsvCell as escape } from './csv.js';

/** The payload verbatim — what a compliance platform ingests. */
export function buildHipaaJson(evidence: HipaaEvidence): string {
  return `${JSON.stringify(evidence, null, 2)}\n`;
}

const CONTROL_HEADER = [
  'control',
  'safeguard',
  'title',
  'coverage',
  'mechanism',
  'greenlight_checks',
] as const;

const PHI_HEADER = [
  'integration',
  'display_name',
  'compliance_tags',
  'baa_state',
  'baa_counterparty',
  'baa_reference',
  'baa_signed_at',
  'baa_expires_at',
  'grant_blocked',
] as const;

/**
 * Two tables in one file, matching the SOC 2 export's shape: the safeguard mapping, then
 * the PHI integrations and the agreement behind each.
 */
export function buildHipaaCsv(evidence: HipaaEvidence): string {
  const lines: string[] = [];
  lines.push(
    escape(`# ${evidence.framework} safeguard coverage — generated ${evidence.generated_at}`),
  );
  lines.push(escape(`# ${evidence.scope_note}`));
  lines.push('');
  lines.push(CONTROL_HEADER.join(','));
  for (const row of evidence.controls) {
    lines.push(
      [row.control, row.safeguard, row.title, row.coverage, row.mechanism, row.policy_ids.join(' ')]
        .map(escape)
        .join(','),
    );
  }
  lines.push('');
  lines.push(PHI_HEADER.join(','));
  for (const phi of evidence.phi_integrations) {
    lines.push(
      [
        phi.name,
        phi.display_name,
        phi.compliance_tags.join(' '),
        phi.baa.state,
        phi.baa.counterparty ?? '',
        phi.baa.reference ?? '',
        phi.baa.signed_at ?? '',
        phi.baa.expires_at ?? '',
        phi.grant_blocked ? 'yes' : 'no',
      ]
        .map(escape)
        .join(','),
    );
  }
  return `${lines.join('\n')}\n`;
}
